module.exports = __webpack_public_path__ + "img/1547469426842.c6eb0db.png";